<template>
    <!-- 微信提示层，默认隐藏 -->
    <div v-if="showWeixinTip" class="weixin-tip">
        <p>请点击右上角↗<br>选择系统浏览器打开</p>
    </div>
    <div>
        <section class="intro-section"> 
            <div class="image-wrapper">
                <div class="text-container"> 
                    <h1 class="header-title" v-html="$t('realFeelAI')"></h1>
                    <p class="intro-description">{{ $t('description') }}</p>
                    <img src="@/assets/images/Frame_6263.png" alt="Item 1" class="log-show" />
                    <div class="button-container">
                        <a :href="apkUrl" download class="link">
                            <button class="custom-button">
                                <img src="@/assets/images/android_download.png" alt="Item 1" class="download-icon" />
                                <span class="download-title">Android</span>
                            </button>
                        </a>
                        <button class="custom-button" @click="handleButtonClick('ios')">
                            <img src="@/assets/images/download-ios.png" alt="Item 1" class="download-icon" />
                            <span class="download-title">iOS</span>
                        </button>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { isAndroid, isIOS, isWeixinBrowser } from '@/utils/deviceDetector';

export default {
    components: {},
    name: 'HomePage',
    setup() {
        const showWeixinTip = ref(false);
        const fileSize = ref(0);
        const apkUrl = '/apk/aikes_v1.apk';
        const config = {
            androidApkUrl: '/apk/aikes_v1.apk',
            iosAppStoreCN: 'https://apps.apple.com/cn/app/aikes/id6714469960',
            iosAppStoreGlobal: 'https://apps.apple.com/us/app/aikes/id6714469960',
            googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.xinteract',
        };
        // 解析URL中的region参数（新增）
        const route = useRoute();
        const region = route.query.region || 'cn';
        // 提取下载逻辑为一个函数
        const downloadAndroid = () => {
            const link = document.createElement('a');
            link.href = apkUrl;
            link.download = 'aikes_v1.apk';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

        // 页面挂载时自动处理
        onMounted(async () => {
            // 获取 APK 文件大小（非核心逻辑，失败不影响主流程）
            try {
                const res = await fetch(config.androidApkUrl, { method: 'HEAD' });
                const size = parseInt(res.headers.get('content-length'), 10) || 0;
                fileSize.value = (size / (1024 * 1024)).toFixed(2);
            } catch (err) {
                console.error('获取文件大小失败:', err);
            }

            // 非微信环境自动触发下载
            if (!isWeixinBrowser()) {
                if (isAndroid()) {
                    await handleDownload('android');
                } else if (isIOS()) {
                    await handleDownload('ios');
                }
            }
        });
                // 处理下载主逻辑
        const handleDownload = async (platform) => {

            // 微信环境提示
            if (isWeixinBrowser()) {
                showWeixinTip.value = true;
                return;
            }

            // 按平台/地域跳转
            if (platform === 'android') {
                region === 'global' 
                    ? window.location.href = config.googlePlayUrl 
                    : downloadAndroid();
            } else if (platform === 'ios') {
                window.location.href = region === 'global' 
                    ? config.iosAppStoreGlobal 
                    : config.iosAppStoreCN;
            }

        };

        const handleButtonClick = (type) => {
            if (type === 'ios') {
                if (isWeixinBrowser()) {
                    showWeixinTip.value = true; // 使用 showWeixinTip.value
                } else {
                    // 跳转到指定的 App Store 链接
                    window.location.href = 'https://apps.apple.com/us/app/aikes/id6714469960';
                }
            }
        };

        return {
            showWeixinTip,
            fileSize,
            apkUrl,
            handleButtonClick
        };
    }
};
</script>

<style scoped>
/* 如果需要scoped特性 */
@import '@/assets/styles/homepage.css';
.weixin-tip {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    color: white;
    padding: 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end; /* 水平靠右 */
    align-items: flex-start; /* 垂直靠上 */
    z-index: 9999;
  }

  .weixin-tip p {
      margin-bottom: 20px;
      font-size: 16px;
      line-height: 1.5;
      font-weight: bold; /* 字体加粗 */
  }
</style>